module.exports = __webpack_public_path__ + "img/president1.b8a9399e.jpg";